import React, { PureComponent } from 'react';

const styles = {
  stickyWrapperSticky: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 999,
  },
};

export default class StickyWrapper extends PureComponent {
  render() {
    const { children, style, isSticky } = this.props;
    return (
      <div
        className="StickyWrapper"
        style={Object.assign(
          {},
          style,
          isSticky ? styles.stickyWrapperSticky : null
        )}
      >
        {children}
      </div>
    );
  }
}
